// Google Analytics GA4 helper
export const track = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

export const trackPageView = (path) => {
  track("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
